import React from "react";

interface CustomTextAreaProps {
  id: string;
  className?: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const CustomTextArea: React.FC<CustomTextAreaProps> = ({
  id,
  className,
  placeholder,
  value,
  onChange,
}) => {
  return (
    <textarea
      id={id}
      className={`form-control ${className || ""}`}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  );
};

export default CustomTextArea;